import { render, staticRenderFns } from "./AlterarDadosServico.vue?vue&type=template&id=da23ffae&scoped=true"
import script from "./AlterarDadosServico.vue?vue&type=script&lang=js"
export * from "./AlterarDadosServico.vue?vue&type=script&lang=js"
import style0 from "./AlterarDadosServico.vue?vue&type=style&index=0&id=da23ffae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da23ffae",
  null
  
)

export default component.exports